import { Star } from "lucide-react";

export default function StarRating({ value = 0, count, size = 16, interactive = false, onRate }) {
  const full = Math.round((value || 0) * 2) / 2; // nearest half
  if (interactive) {
    return (
      <div className="flex items-center gap-1" data-testid="star-rating-interactive">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            data-testid={`rate-star-${n}`}
            onClick={() => onRate?.(n)}
            className="transition-transform hover:scale-110"
            aria-label={`Rate ${n} stars`}
          >
            <Star
              size={size}
              className={n <= value ? "text-[#f5a623]" : "text-[#d6d3e0]"}
              fill={n <= value ? "#f5a623" : "none"}
            />
          </button>
        ))}
      </div>
    );
  }
  return (
    <div className="flex items-center gap-1.5" data-testid="star-rating">
      <div className="flex items-center gap-0.5">
        {[1, 2, 3, 4, 5].map((n) => {
          const filled = n <= Math.floor(full);
          const half = !filled && n - 0.5 <= full;
          return (
            <span key={n} className="relative inline-flex" style={{ width: size, height: size }}>
              <Star size={size} className="text-[#e4e1ee] absolute" fill="#e4e1ee" />
              {(filled || half) && (
                <span className="absolute overflow-hidden" style={{ width: half ? size / 2 : size, height: size }}>
                  <Star size={size} className="text-[#f5a623]" fill="#f5a623" />
                </span>
              )}
            </span>
          );
        })}
      </div>
      {value > 0 && <span className="text-sm font-bold text-[#3c3952]">{value.toFixed(1)}</span>}
      {typeof count === "number" && <span className="text-xs text-[#9a96ac]">({count})</span>}
    </div>
  );
}
